import React, { useEffect } from 'react';
import Tools from '../../cvp-webgames-core/Misc/Tools';
import { PreCacheItem, SinglePreCacheItem, PrecacheItemType } from '../../cvp-webgames-core/pre-caching/pre-cache-item';
import { constants } from '../../misc/constants';
import { BaseConfig } from '../BaseConfig';
import Button1, { Button1Config } from './button1';
import Button2, { Button2Config } from './button2';

import "./pop-up2.css"
import { getGlobalTextSizeStyle, TextHtmlTagType } from '../../misc/tools';

class PopUp2Caching extends PreCacheItem {
	public getItems(): SinglePreCacheItem[] {
		return [
			{
				type: PrecacheItemType.Image,
				key: 'logo',
				src: process.env.PUBLIC_URL + '/assets/images/main-menu/logo.png'
			}
		];
	}
}

export const popUp2Caching = new PopUp2Caching();

const PopUp2 = (props: PopUp2Config) => {

	return (
		<div className="modal-disable-select center-element main-content pop-up2-container" style={{
		}}>
			<div className='pop-up2-row' style={{height: '140px'}}>
				<img className={`pop-up2-logo center-element-vertical ${constants.mainContent508Id}`} src={popUp2Caching.getItemByKey('logo').src} alt={'JCDST (Just Culture Decision Support Tool) Simulation Logo'}/>
				{/*<h1 className='title-text pop-up2-title'>{props.titleLeft}</h1>*/}
			</div>

			<div className='pop-up2-row-right' style={{height: '140px'}}>
				<p style={{...getGlobalTextSizeStyle(TextHtmlTagType.p)}} className='title-text pop-up2-title white-text text-manual-edit-p'>{props.titleRight}</p>
				<p style={{...getGlobalTextSizeStyle(TextHtmlTagType.p)}} className='default-text pop-up2-title white-text text-manual-edit-p'>{props.subtitleRight}</p>
			</div>

			<div className='pop-up2-description pop-up2-row' style={{marginBottom: '10px'}}>
				{props.onRenderContent()}
			</div>
		</div>
	);

};

export interface PopUp2Config extends BaseConfig {
	titleLeft: string;
	titleRight: string;
	subtitleRight: string;
	onRenderContent: () => any;
}

export default PopUp2;